<template>
  <intersect @enter="comeIn()" @leave="comeOut()">
  <div class="on-the-go">
    <div ref="bg" class="bg">
    </div>
    <div ref="bg-blur" class="bg-blur parallax">
    </div>
    <div ref="bg-overlay" class="make-fill bg-overlay grid-bg transparent">
    </div>
    <div class="container content">
      <div ref="copy" class="copy">
        <div class="section-heading">
          {{$t('home.mobile-ad')}}
        </div>
      </div>
    </div>
    <div class="illustrations">

      <div class="container full-height">
        <img ref="htc" class="phone htc" data-src="@/assets/images/htc.png" src="@/assets/images/htc.png"> 
        <img ref="iphone" class="phone iphone" data-src="@/assets/images/iphone-new.png" src="@/assets/images/iphone-new.png">
        <!-- <div class="section-link copy">
          <router-link to="/trade/trading-platforms">About mobile trading</router-link>
        </div> -->
      </div>
    </div>
  </div>
  </intersect>
</template>

<script>

  //JQuery
  var $ = require('jquery')
  import utils from '@/jquery/utils'
  import Intersect from 'vue-intersect'

  export default {
    components: {Intersect},
    mounted: function () {
      this.$nextTick(function () {
        // this.init()
      })
    },
    methods: {
      comeIn() {
        var a = this
        setTimeout(function () {
          $(a.$refs["bg-blur"]).addClass("in")
          $(a.$refs["bg-overlay"]).addClass("in")
          $(a.$refs["copy"]).addClass("in")
          $(a.$refs["htc"]).addClass("in")
          $(a.$refs["iphone"]).addClass("in")
        }, 100)
      },
      comeOut() {
        $(this.$refs["bg-blur"]).removeClass("in") 
        $(this.$refs["copy"]).removeClass("in")
        $(this.$refs["htc"]).removeClass("in")
        $(this.$refs["iphone"]).removeClass("in")
        $(this.$refs["bg-overlay"]).removeClass("in")
      }
    }  
  }
</script>